// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_1qjfK{position:fixed;visibility:hidden;transition-property:visibility;touch-action:pan-y;z-index:900}.container_1qjfK,.scrim_Ob2nl{top:0;bottom:0;right:0;left:0}.scrim_Ob2nl{transition-property:opacity;transform:translateZ(0);opacity:0;background:rgba(0,0,0,.5)}.content_3sjLl,.scrim_Ob2nl{position:absolute}.content_3sjLl{top:0;bottom:0;left:0;width:256px;transition-property:transform;transform:translate3d(-100%,0,0);background-color:#fff}", ""]);
// Exports
exports.locals = {
	"container": "container_1qjfK",
	"scrim": "scrim_Ob2nl",
	"content": "content_3sjLl"
};
module.exports = exports;
